import React, { useState } from "react";
import {
  Typography,
  Grid,
  Card,
  CardContent,
  CardActions,
  Button,
  Box,
  CardMedia,
  Dialog,
  DialogContent,
  IconButton,
  useTheme,
  useMediaQuery,
  Chip,
} from "@mui/material";
import { PlayCircleOutline, Close } from "@mui/icons-material";
import ReactPlayer from "react-player";
import { motion } from "framer-motion";

const videos = [
  { title: "🟢 Atualizações da Plataforma", url: "https://youtu.be/ORaiP4K3R-0?si=fQehPr1ZPQS1GX14", thumbnail: "https://img.youtube.com/vi/ORaiP4K3R-0/hqdefault.jpg" },
  { title: "🟢 Instalação dos Indicadores", url: "https://youtu.be/Tc6CA9lJYoU", thumbnail: "https://img.youtube.com/vi/Tc6CA9lJYoU/hqdefault.jpg" },
  {
    title: "🟢 Média Future VWAP",
    url: "https://youtu.be/xbWQAmMhfMc?si=GzM7iWZQYke4jvpx",
    thumbnail: "https://img.youtube.com/vi/xbWQAmMhfMc/hqdefault.jpg"
  },

  { title: "🟢 Indicadores FuturePro", url: "https://youtu.be/YDzKMLSvUf4?is=aShgoQlVj1dwmRwG", thumbnail: "https://img.youtube.com/vi/YDzKMLSvUf4/hqdefault.jpg" },
  { title: "🟡 Posicionar seu Stop Loss com segurança", url: "https://youtu.be/cZSLhCNoqPo?si=i4dnsbsgZhjNwZUm", thumbnail: "https://img.youtube.com/vi/cZSLhCNoqPo/hqdefault.jpg" },
  { title: "🟢 Automação", url: "https://youtu.be/i_2MBVmeNgI?is=3qSjRefEcFTGgrqV", thumbnail: "https://img.youtube.com/vi/i_2MBVmeNgI/hqdefault.jpg" },
  { title: "🔴 Alarmes para Estratégias", url: "https://youtu.be/pNEVo-_51Hg?si=q8wZnFlrp0mCAVzD", thumbnail: "https://img.youtube.com/vi/pNEVo-_51Hg/hqdefault.jpg" },
  { title: "🟣 Difusor de Fluxo", url: "https://youtu.be/30iGsvUl1Rs", thumbnail: "https://img.youtube.com/vi/30iGsvUl1Rs/hqdefault.jpg" },
  { title: "🔴 Médias Móveis", url: "https://www.youtube.com/watch?v=-UWcYWE2le0", thumbnail: "https://img.youtube.com/vi/-UWcYWE2le0/hqdefault.jpg" },
  { title: "🔵 Indicador MACD", url: "https://youtu.be/Xx7juswUoCo", thumbnail: "https://img.youtube.com/vi/Xx7juswUoCo/hqdefault.jpg" },
  { title: "🟣 Suporte e Resistência", url: "https://youtu.be/AkgU4OmhkDQ", thumbnail: "https://img.youtube.com/vi/AkgU4OmhkDQ/hqdefault.jpg" },
  { title: "🟤 Sinais de Agressão", url: "https://www.youtube.com/watch?v=z3G7aSk4XbE", thumbnail: "https://img.youtube.com/vi/z3G7aSk4XbE/hqdefault.jpg" },
  { title: "🟠 Preço de Ajuste", url: "https://youtu.be/mHNEoa0ugf4", thumbnail: "https://img.youtube.com/vi/mHNEoa0ugf4/hqdefault.jpg" },
  { title: "🟡 Como Proteger seus Trades", url: "https://youtu.be/3HkLVYShpCc", thumbnail: "https://img.youtube.com/vi/3HkLVYShpCc/hqdefault.jpg" },
  { title: "🔵 Aumente seu Patrimônio", url: "https://www.youtube.com/watch?v=-wKAnHlnLd4", thumbnail: "https://img.youtube.com/vi/-wKAnHlnLd4/hqdefault.jpg" },
];


function VideoList() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [open, setOpen] = useState(false);
  const [currentVideo, setCurrentVideo] = useState("");

  const handleOpen = (url) => {
    setCurrentVideo(url);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setCurrentVideo("");
  };

  const getBadge = (video, index) => {
    if (index < 5) return "Essencial";
    if (video.title.includes("Automação")) return isMobile ? "Config. automação" : "Configuração de automação";
    return null;
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, delay: i * 0.1, ease: "easeOut" },
    }),
    hover: {
      y: -5,
      boxShadow: theme.shadows[2],
      transition: { duration: 0.2 },
    },
  };

  return (
    <Box
      sx={{
        minHeight: "100%",
        bgcolor: "transparent",
        position: "relative",
        overflow: "visible",
        py: theme.spacing(3),
        px: isMobile ? 1 : 4,
      }}
    >
      {/* Conteúdo principal */}
      <Box sx={{ position: "relative", zIndex: 1, maxWidth: theme.breakpoints.values.lg, mx: "auto" }}>
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <Typography
            variant={isMobile ? "h5" : "h3"}
            sx={{
              textAlign: "center",
              fontWeight: 800,
              color: "#F4F9FF",
              mb: theme.spacing(1.2),
            }}
          >
            Trilha de Vídeos
          </Typography>
          <Typography
            variant="body1"
            sx={{
              textAlign: "center",
              color: "rgba(231,240,250,0.74)",
              mb: theme.spacing(4),
            }}
          >
            Assista na sequência recomendada para aplicar com mais segurança.
          </Typography>
        </motion.div>

        <Grid container spacing={isMobile ? 1.5 : 3} sx={{ justifyContent: "center" }}>
          {videos.map((video, index) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
              <motion.div
                custom={index}
                variants={cardVariants}
                initial="hidden"
                animate="visible"
                whileHover={isMobile ? undefined : "hover"}
              >
                <Card
                  sx={{
                    height: "auto",
                    minHeight: isMobile ? "290px" : "360px",
                    display: "flex",
                    flexDirection: "column",
                    bgcolor: "rgba(14,22,33,0.95)",
                    background: isMobile
                      ? "linear-gradient(180deg, rgba(14,22,33,0.96) 0%, rgba(10,17,28,0.98) 100%)"
                      : undefined,
                    borderRadius: isMobile ? 2 : 3,
                    border: "1px solid rgba(255,255,255,0.1)",
                    overflow: "hidden",
                    boxShadow: "0 14px 36px rgba(0,0,0,0.3)",
                    position: "relative",
                    "&:hover": { borderColor: "rgba(110,170,255,0.6)" },
                  }}
                >
                  {!isMobile && getBadge(video, index) && (
                    <Chip
                      label={getBadge(video, index)}
                      size="small"
                      sx={{
                        position: "absolute",
                        top: isMobile ? 8 : 10,
                        left: isMobile ? 8 : 10,
                        maxWidth: isMobile ? "76%" : "85%",
                        zIndex: 2,
                        color: "#D4F8E0",
                        bgcolor: "rgba(37,211,102,0.2)",
                        border: "1px solid rgba(37,211,102,0.45)",
                        fontWeight: 700,
                        fontSize: isMobile ? "0.68rem" : "0.75rem",
                        height: isMobile ? 22 : 24,
                        ".MuiChip-label": {
                          px: 1,
                        },
                      }}
                    />
                  )}
                  <CardMedia
                    component="img"
                    height={isMobile ? "170" : "185"}
                    image={video.thumbnail}
                    alt={video.title}
                    sx={{
                      objectFit: "cover",
                      borderBottom: "1px solid rgba(255,255,255,0.1)",
                      transition: isMobile ? "none" : "transform 0.3s ease",
                      "&:hover": isMobile ? {} : { transform: "scale(1.03)" },
                    }}
                  />
                  <CardContent sx={{ p: isMobile ? 1.25 : 1.5, pb: 0.5, flexGrow: 1 }}>
                    {isMobile && getBadge(video, index) && (
                      <Chip
                        label={getBadge(video, index)}
                        size="small"
                        sx={{
                          mb: 1,
                          color: "#D4F8E0",
                          bgcolor: "rgba(37,211,102,0.2)",
                          border: "1px solid rgba(37,211,102,0.45)",
                          fontWeight: 700,
                          fontSize: "0.68rem",
                          height: 22,
                        }}
                      />
                    )}
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 700,
                        color: "#F4F9FF",
                        textAlign: isMobile ? "left" : "center",
                        fontSize: isMobile ? "1rem" : "1.02rem",
                        lineHeight: 1.35,
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        overflowWrap: "anywhere",
                      }}
                    >
                      {video.title}
                    </Typography>
                  </CardContent>
                  <CardActions sx={{ p: isMobile ? 1.25 : 1.5, pt: 0.5, mt: "auto", justifyContent: "center" }}>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => handleOpen(video.url)}
                      startIcon={<PlayCircleOutline />}
                      sx={{
                        borderRadius: 2,
                        px: isMobile ? 1.5 : 3.5,
                        py: 0.9,
                        textTransform: "none",
                        fontWeight: 700,
                        width: isMobile ? "100%" : "auto",
                        color: "#9FC7FF",
                        borderColor: "rgba(159,199,255,0.65)",
                        "&:hover": {
                          bgcolor: "rgba(159,199,255,0.14)",
                          borderColor: "#9FC7FF",
                        },
                      }}
                    >
                      Assistir
                    </Button>
                  </CardActions>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Dialog para o player */}
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        fullScreen={isMobile}
        PaperProps={{
          sx: {
            borderRadius: isMobile ? 0 : 3,
            bgcolor: "rgba(14,22,33,0.98)",
            border: "1px solid rgba(255,255,255,0.1)",
            boxShadow: "0 20px 48px rgba(0,0,0,0.35)",
            overflow: "hidden",
          },
        }}
      >
        <DialogContent sx={{ position: "relative", p: 0 }}>
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.4 }}
          >
            <IconButton
              onClick={handleClose}
              sx={{
                position: "absolute",
                top: theme.spacing(1),
                right: theme.spacing(1),
                zIndex: 1200,
                color: theme.palette.text.primary,
                "&:hover": { bgcolor: `${theme.palette.primary.main}20` },
              }}
            >
              <Close />
            </IconButton>
            <Box
              sx={{
                position: "relative",
                paddingTop: "56.25%", // Proporção 16:9
                bgcolor: "#000",
              }}
            >
              <ReactPlayer
                url={currentVideo}
                playing
                controls
                width="100%"
                height="100%"
                style={{ position: "absolute", top: 0, left: 0 }}
              />
            </Box>
          </motion.div>
        </DialogContent>
      </Dialog>
    </Box>
  );
}

export default VideoList;
